import { ReactElement } from 'react';
import { DriConfigState } from '../types';
import { Select } from '~/components/NewSelect';
import { getKeyByValue } from '../../IntegrRealTime/DriContents';
import {
  driLayerOpts, driMetersCfgs, driParityOpts, driProtocolsOpts, driStopBitsOpts,
  MeterApplications,
  typeFromIsPrimary,
  typesEnergyMetersCircuitsOpts,
} from '~/helpers/driConfigOptions';
import { useTranslation } from 'react-i18next';

interface DriConfigEnergyMeterProps {
  state: DriConfigState;
  render: () => void;
  resetCfgFields: () => void;
}

export function DriConfigEnergyMeter({
  render,
  resetCfgFields,
  state,
}: DriConfigEnergyMeterProps): ReactElement | null {
  const { t } = useTranslation();

  if (state.driApplication !== 'Medidor de Energia') {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14 }}>
      <Select
        style={{ width: '200px' }}
        label={t('modelo')}
        placeholder={t('selecionar')}
        options={state.comboOpts.meterModels}
        propLabel="displayName"
        value={state.driMeterModel}
        onSelect={(item) => {
          state.driMeterModel = item;
          state.selectedCurrentCapacity = null;
          state.selectedInstallationType = null;
          state.driSlaveId = '1';
          const defaultConfig = driMetersCfgs[item.NAME as MeterApplications];

          if (defaultConfig) {
            state.driProtocol = getKeyByValue(driProtocolsOpts, defaultConfig.protocol) || null;
            state.modbusBaudRate = String(defaultConfig.modbusBaudRate);
            state.driParity = getKeyByValue(driParityOpts, defaultConfig.parity) || null;
            state.driLayer = getKeyByValue(driLayerOpts, defaultConfig.serialMode) || null;
            state.driStopBits = getKeyByValue(driStopBitsOpts, defaultConfig.stopBits) || null;
            state.driSendInterval = String(defaultConfig.telemetryInterval);
            state.driSlaveId = defaultConfig.driSlaveId ?? state.driSlaveId;
            state.driIpAddress = defaultConfig.driIpAddress ?? null;
          } else { resetCfgFields(); }
          render();
        }}
      />
      <Select
        style={{ width: '200px' }}
        label={t('quadroEletricoRelativo')}
        placeholder={t('selecionar')}
        options={state.comboOpts.electricCircuits}
        propLabel="name"
        value={state.comboOpts.electricCircuits.find((c) => c.name === state.formData.establishmentName) ?? null}
        onSelect={(item) => {
          state.formData.establishmentName = item?.name ?? '';
          state.formData.driMeterCircuitType = item ? typeFromIsPrimary(item.isPrimary) : null;
          render();
        }}
        disabled={!state.formData.CLIENT_ID_item || !state.formData.UNIT_ID_item || state.comboOpts.electricCircuits.length === 0}
      />
      <Select
        style={{ width: '200px' }}
        label={t('tipoQuadro')}
        placeholder={t('selecionar')}
        options={typesEnergyMetersCircuitsOpts}
        propLabel="name"
        value={state.formData.driMeterCircuitType}
        onSelect={(item) => {
          state.formData.driMeterCircuitType = item?.value;
          render();
        }}
        disabled={!state.formData.establishmentName}
      />
    </div>
  );
}
